import {Component, EventEmitter, Input, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import {DxButtonModule, DxRadioGroupModule, DxToolbarModule} from "devextreme-angular";
import {DxiItemModule} from "devextreme-angular/ui/nested";

@Component({
  selector: 'dk-rapor-pre-selection',
  standalone: true,
    imports: [CommonModule, DxButtonModule, DxRadioGroupModule, DxToolbarModule, DxiItemModule],
  templateUrl: './rapor-pre-selection.component.html',
  styleUrls: ['./rapor-pre-selection.component.scss'],
})
export class RaporPreSelectionComponent {
  @Output() private closePopup = new EventEmitter<string>();
  @Input() options: any[];
  @Input() defaultOption: any;

  constructor() {
  }


  ngOnDestroy(){
    this.defaultOption = null
  }
  setSelectedOptionsRapor($event: any) {
    this.defaultOption = $event;
  }

  handleCancelClick() {

  }

  handleSelectClick() {
    this.closePopup.emit(this.defaultOption)
  }
}
